import {Children, isValidElement, useRef} from "react";
import classNames from "classnames";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";

import {useSlotSliderScroll} from "../hooks/use_slot_slider_scroll";
import {ISlotSliderProps} from "../types/ISlotSliderProps";

import * as styles from "./SlotSlider.module.css";

export const SlotSlider = (props: ISlotSliderProps) => {
    const {
        children,
        header,
        hideNavigation = false,
        alwaysShowNavigation = false,
        prevLabel = "Poprzednie",
        nextLabel = "Następne",
        listLabel,
        itemsPerScroll = 1,
        onNavigate,
        className,
        headerClassName,
        navigationClassName,
        arrowClassName,
        listClassName,
        itemClassName,
        dataTestId
    } = props;

    const listRef = useRef<HTMLUListElement>(null);
    const {isScrollable, canScrollPrev, canScrollNext, scrollByItems} = useSlotSliderScroll(listRef);
    const items = Children.toArray(children);
    const hasNavigation = !hideNavigation && (isScrollable || alwaysShowNavigation);
    const isTrackFocusable = isScrollable && Boolean(listLabel);

    return (
        <div className={classNames(styles.slider, className)} data-testid={dataTestId}>
            {header || hasNavigation ? (
                <div className={classNames(styles.header, !hideNavigation && styles.headerWithNavigation, headerClassName)}>
                    <div className={styles.headerSlot}>{header}</div>

                    {hasNavigation ? (
                        <div className={classNames(styles.navigation, navigationClassName)}>
                            <button
                                type="button"
                                className={classNames(styles.arrow, arrowClassName)}
                                onClick={() => {
                                    if (!canScrollPrev) {
                                        return;
                                    }

                                    scrollByItems(-1, itemsPerScroll);
                                    onNavigate?.("prev");
                                }}
                                aria-disabled={!canScrollPrev}
                                aria-label={prevLabel}
                            >
                                <ChevronLeftIcon size="1.6" fill="currentColor" />
                            </button>

                            <button
                                type="button"
                                className={classNames(styles.arrow, arrowClassName)}
                                onClick={() => {
                                    if (!canScrollNext) {
                                        return;
                                    }

                                    scrollByItems(1, itemsPerScroll);
                                    onNavigate?.("next");
                                }}
                                aria-disabled={!canScrollNext}
                                aria-label={nextLabel}
                            >
                                <ChevronRightIcon size="1.6" fill="currentColor" />
                            </button>
                        </div>
                    ) : null}
                </div>
            ) : null}

            {items.length > 0 ? (
                <ul
                    ref={listRef}
                    role="list"
                    className={classNames(styles.list, listClassName)}
                    aria-label={listLabel}
                    tabIndex={isTrackFocusable ? 0 : undefined}
                >
                    {items.map((item, index) => (
                        <li key={isValidElement(item) && item.key !== null ? item.key : index} className={classNames(styles.item, itemClassName)}>
                            {item}
                        </li>
                    ))}
                </ul>
            ) : null}
        </div>
    );
};
import {Children, isValidElement, useRef} from "react";
import classNames from "classnames";

import {ChevronLeftIcon, ChevronRightIcon} from "@pg-design/icons-module";

import {useSlotSliderScroll} from "../hooks/use_slot_slider_scroll";
import {ISlotSliderProps} from "../types/ISlotSliderProps";

import * as styles from "./SlotSlider.module.css";

export const SlotSlider = (props: ISlotSliderProps) => {
    const {
        children,
        header,
        hideNavigation = false,
        alwaysShowNavigation = false,
        prevLabel = "Poprzednie",
        nextLabel = "Następne",
        listLabel,
        itemsPerScroll = 1,
        onNavigate,
        className,
        headerClassName,
        navigationClassName,
        arrowClassName,
        listClassName,
        itemClassName,
        dataTestId
    } = props;

    const listRef = useRef<HTMLUListElement>(null);
    const {isScrollable, canScrollPrev, canScrollNext, scrollByItems} = useSlotSliderScroll(listRef);
    const items = Children.toArray(children);
    const hasNavigation = !hideNavigation && (isScrollable || alwaysShowNavigation);
    const isTrackFocusable = isScrollable && Boolean(listLabel);

    return (
        <div className={classNames(styles.slider, className)} data-testid={dataTestId}>
            {header || hasNavigation ? (
                <div className={classNames(styles.header, !hideNavigation && styles.headerWithNavigation, headerClassName)}>
                    <div className={styles.headerSlot}>{header}</div>

                    {hasNavigation ? (
                        <div className={classNames(styles.navigation, navigationClassName)}>
                            <button
                                type="button"
                                className={classNames(styles.arrow, arrowClassName)}
                                onClick={() => {
                                    if (!canScrollPrev) {
                                        return;
                                    }

                                    scrollByItems(-1, itemsPerScroll);
                                    onNavigate?.("prev");
                                }}
                                aria-disabled={!canScrollPrev}
                                aria-label={prevLabel}
                            >
                                <ChevronLeftIcon size="1.6" fill="currentColor" />
                            </button>

                            <button
                                type="button"
                                className={classNames(styles.arrow, arrowClassName)}
                                onClick={() => {
                                    if (!canScrollNext) {
                                        return;
                                    }

                                    scrollByItems(1, itemsPerScroll);
                                    onNavigate?.("next");
                                }}
                                aria-disabled={!canScrollNext}
                                aria-label={nextLabel}
                            >
                                <ChevronRightIcon size="1.6" fill="currentColor" />
                            </button>
                        </div>
                    ) : null}
                </div>
            ) : null}

            {items.length > 0 ? (
                <ul
                    ref={listRef}
                    role="list"
                    className={classNames(styles.list, listClassName)}
                    aria-label={listLabel}
                    tabIndex={isTrackFocusable ? 0 : undefined}
                >
                    {items.map((item, index) => (
                        <li key={isValidElement(item) && item.key !== null ? item.key : index} className={classNames(styles.item, itemClassName)}>
                            {item}
                        </li>
                    ))}
                </ul>
            ) : null}
        </div>
    );
};
